window.addEventListener("DOMContentLoaded", (event) => {
  
  // flkty.resize()
  let flicktyOpts = {
    cellAlign: 'left',
    autoPlay: false,
    pauseAutoPlayOnHover: true,
    imagesLoaded: true
  }
  var productsGrid = document.querySelector('.tabcontent.active .product-wrapper');
  var flkty = new Flickity(productsGrid, flicktyOpts);
  
  let tabBtns = document.querySelectorAll('.product-tabination .tablinks');
  if (tabBtns) {
    let tabContent = document.querySelectorAll('.product-tabination .tabcontent');
    tabBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        tabBtns.forEach(btn => btn.classList.remove('active'))
        e.currentTarget.classList.add('active');
        let targetID = e.currentTarget.dataset.id;
        tabContent.forEach(tab => {
          if (tab.id == targetID) {
            tab.classList.add('active');
            var flkty = new Flickity(tab.querySelector('.product-wrapper'), flicktyOpts);
          } else { 
            tab.classList.remove('active')
          }
        })
        
      })
    })
  }
});

